export default __webpack_public_path__ + "static/media/ellipsis-vertical-svgrepo-com.ef913532.svg";